import { render, staticRenderFns } from "./DailyDiary.vue?vue&type=template&id=5fc60f30&"
import script from "./DailyDiary.vue?vue&type=script&lang=js&"
export * from "./DailyDiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports